import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'mb-[32px] flex w-full justify-between',
    baseWithNoSup: 'items-end !justify-start gap-4',
    title: 'heading-2xl',
    actionButton:
      'text-secondary-hover link heading-xs-intr order-3 ml-auto tracking-[0.06em] whitespace-pre uppercase',
    buttonWithNoSup: 'mb-[2px] !ml-0',
    countText: 'heading-xs mb-[2px]'
  },
  variants: {},
  defaultVariants: {}
});
